<template>
  <div>
    <!-- <b-modal ref="my-modal" centered hide-footer :title="(model.uuid === null ? 'Add ' : 'Edit ') + TypeVehicle"> -->
    <b-modal ref="my-modal" centered hide-footer :title="'Edit ' + TypeVehicle">
        <form v-on:submit.prevent="doSubmit">
            <label>Number *</label>
            <b-form-input :required="true" for-input="billNumber" type="number" name="billNumber" id="billNumber" label="Bill Number" placeholder="Enter Number" v-validate="modelValidations.billNumber" :error="errors.first('billNumber')" v-model="model.billNumber" data-vv-as="billNumber"/><br>

            <template v-if="TypeVehicle==='Service'">
              <label>Service Date *</label>
              <b-form-datepicker
                id="serviceDate"
                name="serviceDate"
                v-model="serviceDate"
                v-validate="modelValidations.serviceDate"
                v-bind:class="errors.has('serviceDate') ? 'is-invalid':''"
                locale="en-US"
              ></b-form-datepicker><br>
            </template>
            <!-- <label>Due Date *</label>
            <b-form-datepicker
              id="dueDate"
              name="dueDate"
              v-model="model.dueDate"
              v-validate="modelValidations.dueDate"
              v-bind:class="errors.has('dueDate') ? 'is-invalid':''"
              locale="en-US"
            ></b-form-datepicker><br> -->

            <label>Amount *</label>
            <b-form-input :required="true" for-input="amount" type="text" name="amount" id="amount" label="Amount" placeholder="Enter Amount" v-validate="modelValidations.amount" :error="errors.first('amount')" v-model="model.amount" data-vv-as="amount"/><br>

            <label>Vehicle Bill Photo *</label>
            <div class="expander">
                <b-form-file :required="true" label="Photo" for-input="photoinputGroupFile" :error="errors.first('photoBill')" v-model="model.photoBill">
                    <div class="input-group">
                        <div class="custom-file">
                            <b-form-input type="file" class="custom-file-input" ref="photoBill" @change="onFileSelectedPhoto" id="photoinputGroupFile" accept="image/jpeg, image/png, image/jpg" name="photoBill" v-validate="modelValidations.photoBill" :error="errors.first('photoBill')" data-vv-as="photoBill"/>
                            <label class="custom-file-label" for="photoinputGroupFile">{{model.photoBill !== null ? model.photoBill.name : 'Choose file'}}</label>
                        </div>
                        <div v-if="model.photoBill !== null" class="input-group-append">
                            <span class="input-group-text bg-danger text-white pointer" title="Clear Image" @click="clearImagePhoto"><font-awesome-icon icon="times"/></span>
                        </div>
                    </div>
                </b-form-file>
            </div><br>

            <label>Note</label>
            <b-form-input for-input="note" type="text" name="note" id="note" label="Note" placeholder="Enter Note" v-model="model.note" data-vv-as="note"/><br>
            <b-button variant="primary" class="btn-back float-right" type="submit"><font-awesome-icon icon="save"></font-awesome-icon> Submit </b-button>
            <b-button variant="secondary" class="float-left mr-3" @click="hideModal"><font-awesome-icon icon="times-circle"></font-awesome-icon> Cancel</b-button>
        </form>
    </b-modal>
  </div>
</template>
<script>
  export default {
    props: {
      TypeVehicle: {
        type: String,
        required: false
      }
    },
    data () {
      return {
        apiUrl: {
          vehicleBillInfo: window.AppConfig.apiUrl + 'vehicle-bill-info',
        },
        type: this.TypeVehicle,
        model: {
          uuid: null,
          vehicle: null,
          dueDate: null,
          options: [],
          type: this.TypeVehicle,
          billNumber: null,
          amount: null,
          photoBill: null,
          note: null,
        },
        serviceDate: null,
        modelValidations: {
          billNumber: {
            required: true
          },
          dueDate: {
            required: true
          },
          serviceDate: {
            required: true
          },
          amount: {
            required: true
          },
          photoBill: {
            required: true
          }
        }
      }
    },
    mounted() {
      // this.getUuid()
    },
    methods: {
      // getUuid() {
      //   this.$http.get(this.apiUrl.vehicleBillInfo).then(response => {
      //     response.data._embedded.vehicleBillInfo.forEach(data => {
      //       this.modelUuid = data.uuid
      //     })
      //   })
      //     this.$http.get(this.apiUrl.vehicleBillInfo + '/' + this.modelUuid).then(response => {
      //       response.data._embedded.vehicleBillInfo.forEach(data => {
      //         this.model.amount = response.data.amount
      //       })
      //     })
      // },
      doSubmit() {
        this.$validator.validateAll().then(res => {
          if (res) {
            this.isLoading = true
            this.model.vehicle = this.$route.params.uuid
            if (this.model.type==="Service") {
              let serviceDate = {name: "ServiceDate", value: this.serviceDate};
              this.model.options.push(serviceDate)
            } else if (this.model.type==="Penalty") {
              this.model.options
            } else{ 
              this.model.options
            }
            let form = new FormData();
            form.append('vehicle',this.model.vehicle)
            form.append('dueDate',this.model.dueDate)
            form.append('options', JSON.stringify(this.model.options))
            form.append('type',this.model.type)
            form.append('billNumber',this.model.billNumber)
            form.append('amount',this.model.amount)
            if (this.model.photoBill !== null) {
              form.append('photoBill1', this.model.photoBill, this.model.photoBill.name)
            }
            form.append('note',this.model.note)
            this.$http.post(this.apiUrl.vehicleBillInfo, form).then(() => {
              this.isLoading = false
              this.$store.dispatch('notification/success', this.TypeVehicle + ' successfully added.')
              this.$emit('getVehicleBill')
              this.hideModal()
              this.resetData()
            }).catch(error => {
              this.isLoading = false
              this.$store.dispatch('notification/error', error)
            })
          }
        })
      },
      resetData () {
        this.model.uuid = null
        this.model.note = null
        this.model.amount = null
        this.serviceDate = null
        this.model.dueDate = null
        this.$validator.reset()
      },
      showModal() {
        this.resetData()
        this.$refs['my-modal'].show()
      },
      onFileSelectedPhoto (event) {
        this.model.photo = event.target.files[0]
      },
      clearImagePhoto () {
        this.$refs.photoBill.value = ''
        this.model.photoBill = null
      },
      hideModal () {
        this.resetData()
        this.$refs['my-modal'].hide()
      }
    }
  }
</script>